var ConstructorWidgetEnum = /* @__PURE__ */ ((ConstructorWidgetEnum2) => {
  ConstructorWidgetEnum2["VehicleHeader"] = "vehicle-header";
  ConstructorWidgetEnum2["Finance"] = "finance";
  ConstructorWidgetEnum2["Benefits"] = "benefits";
  ConstructorWidgetEnum2["BenefitsFootnote"] = "benefitsFootnote";
  ConstructorWidgetEnum2["Equipments"] = "equipments";
  ConstructorWidgetEnum2["DealerMap"] = "dealer-map";
  ConstructorWidgetEnum2["DealerComment"] = "dealer-comment";
  ConstructorWidgetEnum2["VehiclesList"] = "vehicles-list";
  ConstructorWidgetEnum2["VehiclesHeader"] = "vehicles-header";
  ConstructorWidgetEnum2["VehiclesCatalog"] = "vehicles-catalog";
  ConstructorWidgetEnum2["VehiclesCatalogHeader"] = "vehicles-catalog-header";
  ConstructorWidgetEnum2["ModelList"] = "model-list";
  ConstructorWidgetEnum2["FilterPanel"] = "filterPanel";
  ConstructorWidgetEnum2["FilterLocation"] = "filter-location";
  ConstructorWidgetEnum2["FilterSelect"] = "filter-select";
  ConstructorWidgetEnum2["FilterMultipleSelect"] = "filter-multiple-select";
  ConstructorWidgetEnum2["FilterCheckboxGroup"] = "filter-checkbox-group";
  ConstructorWidgetEnum2["FilterModels"] = "filter-models";
  ConstructorWidgetEnum2["FilterColorPicker"] = "filter-color-picker";
  ConstructorWidgetEnum2["FilterDuoColorPicker"] = "filter-duo-color-picker";
  ConstructorWidgetEnum2["FilterSlider"] = "filter-slider";
  ConstructorWidgetEnum2["FilterRangeSlider"] = "filter-range-slider";
  ConstructorWidgetEnum2["FilterOptions"] = "filter-options";
  ConstructorWidgetEnum2["FilterHistory"] = "filter-history";
  ConstructorWidgetEnum2["Tile"] = "tile";
  ConstructorWidgetEnum2["TileGallery"] = "tile-gallery";
  ConstructorWidgetEnum2["TileImage"] = "tile-image";
  ConstructorWidgetEnum2["TileHeader"] = "tile-header";
  ConstructorWidgetEnum2["TilePrice"] = "tile-price";
  ConstructorWidgetEnum2["TilePayment"] = "tile-payment";
  ConstructorWidgetEnum2["TileTable"] = "tile-table";
  ConstructorWidgetEnum2["TileLocation"] = "tile-location";
  ConstructorWidgetEnum2["TileMarkers"] = "tile-markers";
  ConstructorWidgetEnum2["TileStatus"] = "tile-status";
  ConstructorWidgetEnum2["TileActions"] = "tile-actions";
  ConstructorWidgetEnum2["Card"] = "card";
  ConstructorWidgetEnum2["CardImage"] = "card-image";
  ConstructorWidgetEnum2["CardTable"] = "card-table";
  ConstructorWidgetEnum2["CardLocation"] = "card-location";
  ConstructorWidgetEnum2["CardPrice"] = "card-price";
  ConstructorWidgetEnum2["CardPayment"] = "card-payment";
  ConstructorWidgetEnum2["CardMarkers"] = "card-markers";
  ConstructorWidgetEnum2["CardTitle"] = "card-title";
  ConstructorWidgetEnum2["CardBookingButton"] = "card-booking-button";
  ConstructorWidgetEnum2["CardActions"] = "card-actions";
  ConstructorWidgetEnum2["FavoritesHeader"] = "favorites-header";
  ConstructorWidgetEnum2["FavoritesList"] = "favorites-list";
  ConstructorWidgetEnum2["ComparisonEquipments"] = "comparison-equipments";
  ConstructorWidgetEnum2["ComparisonHeader"] = "comparison-header";
  ConstructorWidgetEnum2["ComparisonFooter"] = "comparison-footer";
  ConstructorWidgetEnum2["ComparisonList"] = "comparison-list";
  ConstructorWidgetEnum2["ComparisonSpecifications"] = "comparison-specifications";
  ConstructorWidgetEnum2["BookingRequest"] = "booking-request";
  ConstructorWidgetEnum2["Button"] = "button";
  ConstructorWidgetEnum2["Custom"] = "custom";
  return ConstructorWidgetEnum2;
})(ConstructorWidgetEnum || {});
export {
  ConstructorWidgetEnum
};
